const projects = [
  {
    name: "Inteli",
    description: "Inteli (Instituto de Tecnologia e Liderança) is a private, non-profit technology university located in São Paulo, Brazil. Founded in 2019 by financial sector entrepreneurs Roberto Sallouti and André Esteves (associated with BTG Pactual), the institute operates out of a campus within the USP ecosystem. It was established with a philanthropic mission to train future leadership figures capable of transforming society through technology.",
    image: "https://plum-atomic-lemur-391.mypinata.cloud/ipfs/bafkreifptypd5tkbvt4lhajisiyd7kb3fge6mgvtpge5brlu3dv77ilhxu",
    link: "https://www.inteli.edu.br/en/"
  }
];

export const oldProjects = [
  {
    name: "Nexus Labs",
    description: "The Layer 1 for Verifiable Finance.",
    image: "https://plum-atomic-lemur-391.mypinata.cloud/ipfs/bafkreigh7ixxfoyzb22pmxrz6bise6hjdbc7ujyz3kppcoz4a5l523zvvu",
    link: "https://nexus.xyz/"
  },
  {
    name: "Inteli Quantum",
    description: "Official quantum club at Inteli",
    image: "https://plum-atomic-lemur-391.mypinata.cloud/ipfs/bafkreicxl2dw5o63szhkdguwj2vvvh3zusbfbz5s3nhvrx75wf3ywrmdyu",
    link: "https://www.linkedin.com/company/quantum-inteli/"
  },
  {
    name: "Picnic",
    description: "Building the future of finance with Smart Accounts, Account Abstraction, and DeFi innovation.",
    image: "https://plum-atomic-lemur-391.mypinata.cloud/ipfs/bafkreidz2wuwnihmmueob3xrukfux4slg2izi5sikvotlm3owpjlfr35ia",
    link: "https://usepicnic.com"
  },
  {
    name: "Panorama Block",
    description: "Fusing multi-chain data pipelines with AI reasoning frameworks to empower decentralized, composable financial automation.",
    image: "https://plum-atomic-lemur-391.mypinata.cloud/ipfs/bafkreihfw6qikwzzsxeabhxagheaalmnnonocinvmo2jm5n24smwidz6xm",
    link: "https://panoramablock.com/"
  },
  {
    name: "Inteli Blockchain",
    description: "Official blockchain club at Inteli, fostering Web3 education through workshops, hackathons, and collaborative projects.",
    image: "https://plum-atomic-lemur-391.mypinata.cloud/ipfs/bafkreihhdi65jtfsch3sxqq74y66rzfxfvclmtxzjfkosuh5ekhthashty",
    link: "https://www.inteliblockchain.org/"
  },
  {
    name: "Sportiverse",
    description: "Blockchain infrastructure for sports, enabling tokenization, fan engagement, and Web3 integration for athletes and teams.",
    image: "https://plum-atomic-lemur-391.mypinata.cloud/ipfs/bafkreidph62ee64iotjlqogymtf2u23fk3tlctgs3qjase4q4o3nskyume",
    link: "https://www.sportiverse.network/"
  },
  {
    name: "Olympic Birds",
    description: "Transforming Brazil by expanding access to science olympiads and university entrance exams through high-quality educational content.",
    image: require('./imgs/logoinverted.png'),
    link: "https://www.olympicbirds.com.br/"
  },
  {
    name: "Dux",
    description: "Fintech powering the creative economy, enabling creators and businesses to advance receivables in less than 24 hours.",
    image: "https://plum-atomic-lemur-391.mypinata.cloud/ipfs/bafkreia2unccltb2assvgxgmwlhil2r56tezh6ye7hjshgtkxlhbo3u5la",
    link: "https://wearedux.com/"
  },
];

export default projects;
